import React, { useContext, useEffect, useRef, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import { loadModelAction } from "store/actions/modal";
import { RESET_TABLE } from "store/constans";
import { onSelectionChange } from "store/actions/filter";
import { useDashboardState } from "components/DashboardContext";
import { showToast } from "../../utils/helpers";
import {
  getSelection,
  loadModel,
  registerRightClickMethods,
  registerSelectionChangeMethod
} from "utils/builder/IScheduleLogic";
import { addToNewCollection } from "../../store/actions/collections";
import { resizeViewer, isolateSelection, hideSelection, showAll, toggleGhosting } from "utils/builder/IScheduleLogic";
import classNames from "classnames";
import "./EditorSection.scss";

import QuickStats from "components/QuickStats";
import UniversalButton from "components/uiComponents/UniversalButton";

import { ReactComponent as ChangeHeightIcon } from "static/icons/multiselection.svg";
import { ReactComponent as IsolateSelection } from "static/icons/isolate-selection.svg";
import { ReactComponent as HideSelection } from "static/icons/hide-selection.svg";
import { ReactComponent as ShowAll } from "static/icons/show-all.svg";
import { ReactComponent as ToggleGhosting } from "static/icons/toggle-ghosting.svg";
import SaveCollectionModal from "../modals/SaveCollectionModal";
import {ModalContext} from "../ModalContext";

const EditorSection = ({
    autodesk,
    projectData,
    quickCounterData,
    sidebarIsOpened,
    table
}) => {
    const dispatch = useDispatch();
    const viewer = useRef();

    const {
        isTableHidden,
        setIsTableHidden,
        setIsModalLoaded,
    } = useDashboardState();

  const { compare, quickInfoCompare } = useSelector((state) => state.viewer);

  const [editorPanel, setEditorPanel] = useState({isolateSelection: false, hideSelection: false, showAll: false, toggleGhosting: true});

  const { handleModal } = useContext(ModalContext);

    useEffect(() => {
        setTimeout(() => {
            resizeViewer();
        }, 510);
    }, [isTableHidden]);

    const handleHideTable = () => {
        setIsTableHidden(!isTableHidden);
    };

    const callback = (res) => {
        setIsModalLoaded({ status: true });

        dispatch(loadModelAction(res));

        registerRightClickMethods(saveAsCollection, createNewCollection);

        toggleGhosting(true);
    };

    const onSelectionChangeCallback = (res) => {
        dispatch(onSelectionChange(res));
    };

  const createNewCollection = async () => {
    const selectionElementOnViewer = await getSelection();

    try {
        await dispatch(addToNewCollection({ elements: selectionElementOnViewer, properties: ["Type Name", "Description", "Length", "Area", "Volume"], groups: []}));
      showToast(true,"New selection set was created");
    } catch (error) {
        showToast(false, "New selection set was not created");
    }
  }

  const saveAsCollection = async () => {
    const selectionElementOnViewer = await getSelection();

    handleModal(
        <SaveCollectionModal tableInfo={{ collection: { properties: ["Type Name", "Description", "Length", "Area", "Volume"], groupBy: []}, lineElements: selectionElementOnViewer}}/>
    );
  }

  useEffect(() => {
      if (
          projectData &&
          viewer.current &&
          autodesk &&
          viewer.current.children.length < 1
      ) {
          dispatch({
              type: RESET_TABLE,
          });

          loadModel(projectData, callback, viewer.current);
          registerSelectionChangeMethod(onSelectionChangeCallback);
      }
  }, [
      viewer.current,
      projectData,
      autodesk,
  ]);

  const isSelectCollection = () => {
    return Object.values(compare.collections).flat(2).some((collection) => collection.checked);
  }

  const handleClickButton = (buttonName, buttonMethod) => {
    setEditorPanel({...editorPanel, [buttonName]: !editorPanel[buttonName]})
    buttonMethod();
  }

  return (
      <div className="editor-section">
          <div className="editor-section__body">
            {quickCounterData && quickCounterData[0].value !== 0 && isTableHidden && !compare.isModeCompare &&
                <QuickStats
                    quickCounterData={quickCounterData}
                    sidebarIsOpened={sidebarIsOpened}
                />
            }
            {
              isSelectCollection() &&
              <QuickStats
                quickCounterData={quickInfoCompare}
                sidebarIsOpened={sidebarIsOpened}
                isCompare={true}
              />
            }
            <div className="editor-panel" style={!!table.tabs.length && !compare.isModeCompare ? {bottom: "66px"} : {bottom: "16px"}}>
              <UniversalButton
                centerIcon={<ShowAll />}
                size="lg"
                labelColor="white"
                labelHoverColor="white"
                onClick={() => handleClickButton("showAll", showAll)}
              />
              <UniversalButton
                centerIcon={<IsolateSelection />}
                size="lg"
                labelColor="white"
                labelHoverColor="white"
                onClick={() => handleClickButton("isolateSelection", isolateSelection)}
              />
              <UniversalButton
                centerIcon={<HideSelection />}
                size="lg"
                labelColor="white"
                labelHoverColor="white"
                onClick={() => handleClickButton("hideSelection", hideSelection)}
              />
              <UniversalButton
                centerIcon={<ToggleGhosting />}
                size="lg"
                labelColor="white"
                labelHoverColor="white"
                backgroundColor={editorPanel.toggleGhosting ? "orange" : "gray6"}
                backgroundHoverColor={editorPanel.toggleGhosting ? "orange-light" : "gray5"}
                onClick={() => handleClickButton("toggleGhosting", () => toggleGhosting(!editorPanel.toggleGhosting))}
              />
            </div>
            {
              (!!table.tabs.length && !compare.isModeCompare) &&
              <div className="editor-section__height-button">
                <UniversalButton
                  centerIcon={<ChangeHeightIcon />}
                  size="lg"
                  labelColor="white"
                  labelHoverColor="white"
                  backgroundColor={isTableHidden ? "orange" : "gray6"}
                  backgroundHoverColor={isTableHidden ? "orange-light" : "gray5"}
                  onClick={handleHideTable}
                />
              </div>
            }

              <div
                  className={classNames({
                      "editor-section__viewer": true,
                      "editor-section__viewer--short": !isTableHidden,
                  })}
                  ref={viewer}
              />
          </div>
      </div>
  );
};

export default EditorSection;
